"use client";
import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import StarIcon from "@mui/icons-material/Star";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";

interface ReviewProps {
  reviewData: any;
}

const Review: React.FC<ReviewProps> = ({ reviewData }) => {
  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    className: "myCustomCarousel",
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {reviewData && reviewData?.length > 1 ? (
        <Box
          className="review-shell"
          sx={{
            marginTop: 0,
            width: "var(--salontym-content-width)",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "var(--salontym-section-gap)",
            background:
              "linear-gradient(145deg, rgba(16,33,23,0.98) 0%, rgba(26,55,38,0.96) 54%, rgba(91,45,31,0.92) 100%)",
            padding: { xs: "1.25rem 0.2rem 1rem", sm: "1.8rem 0.4rem 1.2rem" },
            borderRadius: { xs: "28px", sm: "38px" },
            boxShadow: "0 28px 80px rgba(11, 26, 19, 0.2)",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              right: "-4rem",
              top: "-4rem",
              width: "14rem",
              height: "14rem",
              borderRadius: "999px",
              background:
                "radial-gradient(circle, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0) 72%)",
            }}
          />
          <Grid item container xs={12} sm={12} md={12} lg={12} margin="auto">
            <Box
              sx={{
                textAlign: "center",
                flexDirection: "column",
                alignItems: "center",
                width: "100% ",
                position: "relative",
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  textAlign: "center",
                  color: "#fff8f1",
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0.4rem auto 1.8rem",
                  gap: "0.65rem",
                  padding: "0 1rem",
                }}
              >
                <Typography className="section-eyebrow review-eyebrow">
                  Client love
                </Typography>
                <Typography variant="h4" className="review-heading">
                  Happy Customers, beautifully experienced
                </Typography>
                <Typography className="review-subcopy">
                  Real stories from clients who booked, relaxed, and came back
                  for the experience.
                </Typography>
              </Box>
              <Box>
                <Slider {...settings}>
                  {reviewData?.map((item: any, index: number) => (
                    <Box
                      key={index}
                      sx={{
                        minWidth: "17rem",
                        minHeight: "24rem",
                        borderRadius: "1.5rem",
                        position: "relative",
                        background:
                          "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(250,245,239,0.96) 100%)",
                        padding: "1.15rem",
                        boxShadow: "0 22px 40px rgba(11, 26, 19, 0.16)",
                        maxWidth: {
                          xs: "80%",
                          sm: "80%",
                          md: "80%",
                          lg: "80%",
                        },
                        margin: "0.5rem auto",
                      }}
                    >
                      <Box className="testimonial-icon">
                        <FormatQuoteIcon sx={{ fontSize: "2rem" }} />
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          margin: "8px auto",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{ textTransform: "capitalize" }}
                        >
                          {item?.name}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "black",
                          margin: "8px auto",
                        }}
                      >
                        <StarRating rating={item?.rating} />
                      </Box>
                      <Box
                        sx={{
                          overflow: "scroll",
                          "&:: -webkit-scrollbar": {
                            display: "none",
                          },
                        }}
                        >
                          {item?.professionalStatements?.map(
                            (item: any, index: number) => (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "start",
                              }}
                              key={index}
                            >
                              <CheckIcon
                                sx={{
                                  color: "#1f7a4d",
                                  paddingRight: "5px",
                                  fontSize: "1rem",
                                }}
                              />
                              <Typography
                                variant="caption"
                                sx={{ color: "black", textAlign: "left" }}
                              >
                                {item?.value}
                              </Typography>
                            </Box>
                          )
                        )}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          margin: "8px auto",
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            textTransform: "capitalize",
                            position: "absolute",
                            bottom: 10,
                            color: "#1f7a4d",
                            height: "3em",
                            maxWidth: "-webkit-fill-available",
                            margin: "0px 16px",
                            fontWeight: "bold",
                            overflow: "scroll",
                            "&:: -webkit-scrollbar": {
                              display: "none",
                            },
                          }}
                        >
                          {item?.feedback}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Slider>
              </Box>
            </Box>
          </Grid>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};

interface StarRatingProps {
  rating: any;
}

const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    const starColor = i <= rating ? "#15741a" : "#d2cccc";
    stars.push(
      <StarIcon
        key={i}
        sx={{
          fontSize: "22px",
          color: starColor,
          marginRight: "8px",
        }}
      />
    );
  }

  return <>{stars}</>;
};

export default Review;
